import { Link } from 'expo-router';
import React from 'react';
import { StyleSheet } from 'react-native';

import { Text, tokens } from '@fhs/ui';

export const PromotionalEmailsLabel = () => {
  return (
    <Text testID={'opt-in-label-acceptEmailsAndSpecialOffers'}>
      I want to receive special offers and other information from Firehouse Subs®
    </Text>
  );
};

export const TermsOfServiceLabel = ({ error = false }: { error: boolean }) => {
  const privacyPolicyLink = (
    <Link href="/privacy-policy" style={styles.link}>
      Privacy Policy
    </Link>
  );

  const rewardsPolicyLink = (
    <Link href="/terms-conditions-rewards" style={styles.link}>
      Firehouse Rewards Terms
    </Link>
  );

  const termsOfServiceLink = (
    <Link href="/terms-of-service" style={styles.link}>
      Terms of Service
    </Link>
  );

  return (
    <Text style={[error && styles.errorLink]}>
      By checking this box, you acknowledge that you have read and agree to our {termsOfServiceLink}{' '}
      including the mandatory arbitration clause, {privacyPolicyLink} and {rewardsPolicyLink}
    </Text>
  );
};

const styles = StyleSheet.create({
  link: {
    color: tokens.colors.$houseRedDarken,
    textDecorationLine: 'underline',
  },
  errorLink: {
    color: tokens.colors.$houseRedDarken,
  },
});
